<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" PagingC>
          <Paging
            :resourceSettings="resourceSettings"
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" updates>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-3" @click.prevent="dialog = true">
              <v-icon class="mr-2" small>remove_red_eye</v-icon>
              <span>Quick review</span>
            </v-btn>
            <v-spacer></v-spacer>
          </div>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-timeline dense clipped>
                <v-timeline-item
                  v-for="(timeline, key) in resource.data"
                  :key="`call-${key}`"
                  :color="timeline.pending ? 'grey' : timeline.approved ? 'success' : 'red'"
                  icon-color="grey lighten-2"
                  small
                >
                  <v-row justify="space-between" class="align-center elevation-2 px-2 py-4" style="border-radius: 3px">
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["aramcco_code"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.candidate.aramcco_code }}</div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["name"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.candidate.name }}</div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["updated_field"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.update_field }}</div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["updated_value"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.update_value }}</div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["updated_status"] }}
                      </div>
                      <v-chip small v-if="timeline.pending" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                        i18n["pending"]
                      }}</v-chip>
                      <v-chip
                        small
                        color="success"
                        v-if="timeline.approved"
                        :class="`${arabic ? 'arFont' : 'enFont'}`"
                        >{{ i18n["approved"] }}</v-chip
                      >
                      <v-chip small color="error" v-if="timeline.rejected" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                        i18n["rejected"]
                      }}</v-chip>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["last_update"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ getFormat(timeline.updated_at) }}</div>
                    </v-col>
                    <v-col cols="12" v-if="timeline.note" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["note"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.note }}</div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>

              <acceptRejectUpdateDialog
                ref="dialog"
                :loading="loading"
                :dialog="dialog"
                :pendingUpdates="pendingUpdates"
                :hasMorePages="page < resource.last_page"
                @closeDialog="
                  () => {
                    dialog = false;
                    loadResource();
                  }
                "
                @nextPage="nextPage"
                @loadResource="loadResource"
                @closeGetResource="
                  () => {
                    dialog = false;
                    loadResource();
                  }
                "
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Paging from "@/components/Paging";
import { format } from "timeago.js";
import acceptRejectUpdateDialog from "@/components/acceptRejectUpdateDialog.vue";

export default {
  components: {
    Paging,
    acceptRejectUpdateDialog,
  },
  data() {
    return {
      page: 1,
      dialog: false,
      loading: false,
      resource: [],
      search: null,
      resourceSettings: {
        pagination: true,
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
    pendingUpdates() {
      if (this.resource.data) return this.resource.data;
      return [];
    },
  },
  methods: {
    async nextPage() {
      await this.pageByNumber(this.page + 1);
    },
    getFormat(d) {
      return format(d);
    },
    async loadResource() {
      this.loading = true;
      this.resource = await this.$store.dispatch("getResource", { resource: "/can/get_all_/updates" });
      this.loading = false;
    },
    async pageByNumber(n) {
      this.page = n
      this.loading = true;
      this.resource = await this.$store.dispatch("getResource", { resource: `/can/get_all_/updates?page=${n}` });
      this.loading = false;
    },
  },
  async created() {
    await this.loadResource();
    document.addEventListener("keydown", (e) => {
      if (this.dialog) {
        this.$refs.dialog.onKeyDown(e)
      }
    });
  },
};
</script>
